import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import { NamespacedStoreState } from '@Types/store.types';
import { useSelector } from 'react-redux';

const areIntegrationsInitialized = (state: NamespacedStoreState) =>
	state[moduleNamespace].integrations.initialized;

const integrationById = (state: NamespacedStoreState) =>
	state[moduleNamespace].integrations.integrationById;

export const useIsIntegrationsInitialized = () =>
	useSelector(
		createSelector(
			[areIntegrationsInitialized],
			integrations => integrations,
		),
	);

export const useIntegrationById = () =>
	useSelector(createSelector([integrationById], intById => intById));
